import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BasePriceForm } from '@/features/dashboard/tourConfig/schemas/tourPricesSchema.ts';
import tourPricesApi from '@/features/dashboard/tourConfig/api/tourPricesApi.ts';
import { tourPriceDtoMapper } from '@/features/dashboard/tourConfig/types/TourPriceDto.mapper.ts';
import { toast } from 'sonner';
import { tourPricesApiQueryKeys } from '@/features/dashboard/tourConfig/api/tourPricesApi.queryKeys.ts';

export default function useWriteTourPrices(tourId: string) {
  const queryClient = useQueryClient();

  const writeTourPrices = async (tourPricesForm: BasePriceForm) => {
    const dto = tourPriceDtoMapper.fromFormToDto(tourId, tourPricesForm);
    return await tourPricesApi.writePrices(dto);
  };

  return useMutation({
    mutationFn: writeTourPrices,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourPricesApiQueryKeys.byTour(tourId),
      });
      toast.success('Koszty zostały zapisane');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd podczas zapisywania kosztów', {
        description: error.message,
      });
    },
  });
}
